import React from 'react';
import YoutubeVideoCategoriesApi from '../../components/admin/YoutubeVideoCategoriesApi';

const YoutubeVideoCategoriesApiPage = () => {
  return <YoutubeVideoCategoriesApi />;
};

export default YoutubeVideoCategoriesApiPage;
